import React, { useState, useEffect } from 'react';
import {
    Grid, Switch, Typography, Button, CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Box, List, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import {
    getQboSetting,
    updateQboSetting,
    createQboSetting
} from './administration/actions/administration';
import {
    showErrorToast,
    showSuccessToast
} from '../../common/components/Helper/Utils';
import HelpIcon from '@material-ui/icons/Help';
import { SpinnerRoundFilled } from "spinners-react";
import { set } from 'lodash';

const useStyles = makeStyles(() => ({
    gridItemTwo: {
        display: "flex",
        alignItems: "center"
    },
}));

const QboSettings = () => {
    const classes = useStyles();
    const [enable, setEnable] = useState(true);
      const [settingId, setSettingId] = useState(null);
    const [enableFeature, setEnableFeature] = useState({
        qbo_include_fees: true,
        qbo_include_tax: true,
        qbo_invoice_mode1: true,
        qbo_invoice_automatically: true,
    });
    const [settingsView, setSettingsView] = useState(false);
    const [loader, setloader] = useState(true);

    useEffect(() => {
        getQboSettingData();
    }, []);

    const getQboSettingData = () => {
        setloader(true);
        getQboSetting((err, response) => {
            if (response?.status === 1) {
                const data = response.data;
                setSettingId(data.id ?? null);
                setEnableFeature({
                    qbo_include_fees: data.qbo_include_fees,
                    qbo_include_tax: data.qbo_include_tax,
                    qbo_invoice_mode1: data.qbo_invoice_mode1,
                    qbo_invoice_automatically: data.qbo_invoice_automatically,
                });
            }
            setloader(false);
        })
    };

    const handleToggle = (key) => {
        setEnableFeature(prev => {
            const newState = {
                ...prev,
                [key]: !prev[key]
            };
            return newState;
        });
    };

    const handleOnEdit = () => {
        setEnable(false);
    };

   const submitData = () => {
    setSettingsView(true)
    const accountid = window.sessionStorage.getItem('accountId');

    const payload = {
        accountid,
        qbo_include_fees: enableFeature.qbo_include_fees,
        qbo_include_tax: enableFeature.qbo_include_tax,
        qbo_invoice_mode1: enableFeature.qbo_invoice_mode1,
        qbo_invoice_automatically:enableFeature.qbo_invoice_automatically
    };

    if (settingId) {
        // Edit (Update)
        payload.id = settingId;
        updateQboSetting(payload, (err, response) => {
            if (response?.status === 1) {
                setSettingsView(false)
                setEnable(true);
                getQboSettingData();
                showSuccessToast("Updated Successfully");
            } else {
                showErrorToast("Update Failed");
            }
        }).catch((e) => {
            console.error("Update error:", e);
            showErrorToast("Update Failed");
        });
    } else {
        // Create
        createQboSetting(payload, (err, response) => {
            if (response?.status === 1) {
                setSettingsView(false)
                setEnable(true);
                // setSettingId(response.id ?? response.data?.id ?? null);
                getQboSettingData();
                showSuccessToast("Created Successfully");
            } else {
                showErrorToast("Creation Failed");
            }
        }).catch((e) => {
            console.error("Create error:", e);
            showErrorToast("Creation Failed");
        });
    }
};
    if (loader) {
            return (
                <div className="d-spinner">
                    <SpinnerRoundFilled
                        size={51}
                        thickness={125}
                        speed={80}
                        color="rgba(57, 107, 172, 1)"
                        className="spp"
                        enabled={loader}
                    />
                </div>
                );
    }
    return (
        <Grid item xs={12} md={6}>
            <div style={{ marginTop: '20px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="flex-end">
                            {enable && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleOnEdit}
                                    className="primary-bg color-white text-center1 form-width-20"
                                >
                                    EDIT
                                </Button>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" component="p" className="primary-text uppercase">
                            Quickbook Settings
                        </Typography>
                    </Grid>

                    <Grid item xs={8} md={8} className={classes.gridItemTwo}>
                        <Typography variant="caption">Send sales tax as a line item to Quickbook</Typography>
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Switch
                            checked={enableFeature.qbo_include_tax}
                            disabled={enable}
                            onChange={() => handleToggle('qbo_include_tax')}
                        />
                    </Grid>

                    <Grid item xs={8} md={8} className={classes.gridItemTwo}>
                        <Typography variant="caption">Send fees as a line items to Quickbook</Typography>
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Switch
                            checked={enableFeature.qbo_include_fees}
                            disabled={enable}
                            onChange={() => handleToggle('qbo_include_fees')}
                        />
                    </Grid>

                    <Grid item xs={8} md={8} className={classes.gridItemTwo}>
                        <Typography variant="caption">{enableFeature.qbo_invoice_mode1 ? 'QuickBooks Online is for Accounting Purposes only (WatchOps is the system of record for all invoice data)' : 'QuickBooks Online is the System of Record for Invoice Data (WatchOps will NOT track all invoice changes, payments, … )'}</Typography>
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Switch
                            checked={enableFeature.qbo_invoice_mode1}
                            disabled={enable}
                            onChange={() => handleToggle('qbo_invoice_mode1')}
                        />
                    </Grid>

                    {!enableFeature.qbo_invoice_mode1 && (
                    <Grid item xs={12}>
                        <Box mt={1}>
                        {/* Header */}
                        <Box display="flex" alignItems="center" mb={1}>
                            <PriorityHighIcon
                            fontSize="medium"
                            sx={{ color: '#d32f2f', mr: 0.5 }}
                            />
                            <Typography variant="subtitle1">
                            Important Information
                            </Typography>
                        </Box>

                        {/* Numbered Disclaimer list */}
                        <List disablePadding sx={{ml: 4}}>
                            <ListItem disableGutters alignItems="flex-start" style={{padding: 0, alignItems: 'center'}}>
                            <ListItemIcon sx={{ minWidth: 28, marginTop: '0'}}>
                                <Typography variant="body2" fontWeight={600}>1.</Typography>
                            </ListItemIcon>
                            <ListItemText style={{ fontSize: '12px'}}
                                primary="WatchOps is NOT responsible for any invoice changes that take place in QuickBooks Online."
                            />
                            </ListItem>

                            <ListItem disableGutters alignItems="flex-start" style={{padding: 0, alignItems: 'center'}}>
                            <ListItemIcon sx={{ minWidth: 28, marginTop: '0' }}>
                                <Typography variant="body2" fontWeight={600} marginTop={0}>2.</Typography>
                            </ListItemIcon>
                            <ListItemText style={{ fontSize: '12px'}}
                                primary="Changes made in QuickBooks Online will not automatically be reflected in WatchOps."
                            />
                            </ListItem>

                            <ListItem disableGutters alignItems="flex-start" style={{padding: 0, alignItems: 'center'}}>
                            <ListItemIcon sx={{ minWidth: 28, marginTop: '0' }}>
                                <Typography variant="body2" fontWeight={600}>3.</Typography>
                            </ListItemIcon>
                            <ListItemText style={{ fontSize: '12px'}}
                                primary="Changes made in QuickBooks Online will not be included in WatchOps profit dashboard calculations. Profit dashboards rely only on invoice data within WatchOps."
                            />
                            </ListItem>
                        </List>
                        </Box>
                    </Grid>
)}

                    {enableFeature?.qbo_invoice_mode1 && (
                        <>
                            <Grid item xs={8} md={8} className={classes.gridItemTwo}>
                                <Typography variant="caption">
                                    Send invoices {enableFeature.qbo_invoice_automatically ? 'AUTOMATICALLY' : 'MANUALLY'} to QuickBooks Online
                                </Typography>
                                <Tooltip title={enableFeature.qbo_invoice_automatically ? "When an invoice is marked as 'Fully Paid', it will be automatically created in QuickBooks Online." : "When an invoice is marked as 'Fully Paid', you have the flexibility to decide when it is sent to QuickBooks Online."} arrow 
                                componentsProps={{
                                        tooltip: {
                                        sx: {
                                            backgroundColor: '#000', // dark slate
                                            color: '#fff',
                                            fontSize: '12px',
                                            padding: '8px 12px',
                                        },
                                        },}}
                                >
                                       <HelpIcon style={{ opacity: '0.7', fontSize: '17px', marginLeft: '8px', cursor: 'poniter'}}/>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <Switch
                                    checked={enableFeature.qbo_invoice_automatically}
                                    disabled={enable}
                                    onChange={() => handleToggle('qbo_invoice_automatically')}
                                />
                            </Grid>
                        </>
                    )}
                    
                  
                    {!enable && (
                        <>
                            <Grid item xs={6} md={3}>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setEnable(true);
                                        getQboSettingData();
                                    }}
                                    className="primary-bg color-white text-center1 form-width-20"
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={submitData}
                                    className="primary-bg color-white text-center1 form-width-20"
                                    disabled={settingsView}
                                      endIcon={
                                     settingsView ? ( <CircularProgress style={{ width: 22, height: 22, color: "#fff" }} />
                                                                                                    ) : null
                                                                                                    } 
                                >
                                    Update
                                </Button>
                            </Grid>
                        </>
                    )}
                </Grid>
            </div>
        </Grid>
    );
};

export default QboSettings;
